import React from 'react';
import { v4 } from 'uuid';

import Chart from './Chart';

export default React.memo(({ data, toConfig, setChart, single = true, height, unitId }) =>
  single ? (
    <Chart
      setChart={setChart}
      key={v4()}
      config={toConfig(
        data.flatMap((d) => d),
        single
      )}
      height={height}
      unitId={unitId}
    />
  ) : (
    data.map((chartData) => (
      <Chart
        setChart={setChart}
        key={v4()}
        config={toConfig(Array.isArray(chartData) ? chartData : [chartData], single)}
        height={height}
        unitId={unitId}
      />
    ))
  )
);
